import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-audit',
  templateUrl: './service-audit.component.html',
  styleUrls: ['./service-audit.component.scss']
})
export class ServiceAuditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
